import axios from 'axios';

import dotenv from 'dotenv';
dotenv.config();

/**
 * Returns a users plan, email info based on apikey
 * @param {*} apiKey apikey to return user data for
 */
const getApiPlan = async (apiKey) => {
  const url = `${process.env.REACT_APP_API_BASE}/api/v1/plan`;

  try {
    let { data, status } = await axios({
      method: 'get',
      url,
      headers: {
        'x-api-key': apiKey,
      },
      validateStatus: false,
    });

    //api returns status value in body so just return this
    return data;
  } catch (e) {
    console.log(e);
    return;
  };
}

export default getApiPlan;